import { Component} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FileService } from '../service/file.service';

@Component({
  selector: 'dpi-file-upload',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss'
})
export class FileUploadComponent {
  fileName = '';
  
  constructor(private service : FileService) {}

  onFileSelected(event : any) {   
    const file:File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.service.fileUpload(file).subscribe({
        next: res => {},
        error: err => {
          console.log(err);
        }
    });
    }
  }
}